import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface Series {
  key: string;
  label: string;
  color: string;
}

interface Props {
  data: Array<Record<string, any>>;
  series: Series[];
  height?: number;
}

export function SimpleBarChart({ data, series, height = 280 }: Props) {
  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 16, right: 16, bottom: 16, left: 0 }}>
          <CartesianGrid stroke="#d9d9dd" vertical={false} />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 11, fill: '#75758a' }}
            tickFormatter={(d: string | number) => {
              const date = new Date(d);
              return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
            }}
            stroke="#d9d9dd"
          />
          <YAxis tick={{ fontSize: 11, fill: '#75758a' }} allowDecimals={false} stroke="#d9d9dd" />
          <Tooltip
            contentStyle={{ background: '#fff', border: '1px solid #d9d9dd', borderRadius: 8, fontSize: 12 }}
            labelStyle={{ color: '#212121' }}
          />
          <Legend wrapperStyle={{ fontSize: 12, paddingTop: 12 }} />
          {series.map((s) => (
            <Bar key={s.key} dataKey={s.key} name={s.label} fill={s.color} radius={[4, 4, 0, 0]} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
